"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _max = _interopRequireDefault(require("lodash/max"));

var _luxon = require("luxon");

var _helpers = require("../../helpers");

var _colors = require("./colors");

var _chartUtils = require("../../chartUtils");

var _chartDataTypes = require("../../constants/chartDataTypes");

var _chartDisplayTypes = require("../../constants/chartDisplayTypes");

var _Styles = require("./Styles");

var _CustomerDisplay = _interopRequireDefault(require("./CustomerDisplay"));

var _CustomerInteraction = _interopRequireDefault(require("./CustomerInteraction"));

var _ScrollableXYPlot = _interopRequireDefault(require("./ScrollableXYPlot"));

var _ChartTick = _interopRequireDefault(require("./ChartTick"));

var _CustomerHint = _interopRequireDefault(require("./CustomerHint"));

var _CustomerLegend = _interopRequireDefault(require("./CustomerLegend"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createKey = function createKey(dt, minuteInterval) {
  var minute = parseInt(dt.get('minute'), 10);

  if (minuteInterval === 15 || minuteInterval === 30) {
    var minuteOffset = parseInt(minute / minuteInterval, 10) * minuteInterval;
    return dt.startOf('hour').plus({
      minute: minuteOffset
    }).toISO();
  }

  return dt.startOf('hour').toISO();
};

var extractConsumptionValue = function extractConsumptionValue(consumptionObj) {
  if (consumptionObj && (0, _chartUtils.isNumeric)(consumptionObj.estimatedConsumptionKwh)) {
    return Number(consumptionObj.estimatedConsumptionKwh);
  }

  if (consumptionObj && (0, _chartUtils.isNumeric)(consumptionObj.consumptionKwh)) {
    return Number(readingDictionary[x].consumptionKwh);
  }

  return 0;
};

var getEdgeDates = function getEdgeDates(dayISO, zone, readingDictionary, batteryDictionary, enabledDataTypes) {
  var originalStartDate = _luxon.DateTime.fromISO(dayISO, {
    zone: zone
  }).startOf('day').plus({
    hour: 4
  });

  var originalEndDate = _luxon.DateTime.fromISO(dayISO, {
    zone: zone
  }).endOf('day').minus({
    hour: 4
  });

  var startDate = _luxon.DateTime.fromISO(dayISO, {
    zone: zone
  }).startOf('day').plus({
    hour: 4
  });

  var endDate = _luxon.DateTime.fromISO(dayISO, {
    zone: zone
  }).endOf('day').minus({
    hour: 4
  });

  var hasConsumption = enabledDataTypes.indexOf(_chartDataTypes.CONSUMPTION) > -1;
  var hasBattery = enabledDataTypes.indexOf(_chartDataTypes.BATTERY) > -1;
  var hasProduction = enabledDataTypes.indexOf(_chartDataTypes.PRODUCTION) > -1;

  if (hasConsumption || hasProduction) {
    Object.keys(readingDictionary).forEach(function (element) {
      var elementDateTime = _luxon.DateTime.fromISO(readingDictionary[element].readingEndTimeLocal, {
        zone: zone
      });

      var consumptionValue = hasConsumption ? extractConsumptionValue(readingDictionary[element]) : 0;
      var productionValue = hasProduction ? readingDictionary[element].deliveredKwh : 0;

      if ((0, _chartUtils.isNumeric)(consumptionValue) && consumptionValue > 0 && elementDateTime < startDate && elementDateTime.hasSame(startDate, 'day') || (0, _chartUtils.isNumeric)(productionValue) && productionValue > 0 && elementDateTime < startDate && elementDateTime.hasSame(startDate, 'day')) {
        startDate = elementDateTime;
      }

      if ((0, _chartUtils.isNumeric)(consumptionValue) && consumptionValue > 0 && elementDateTime > endDate && elementDateTime.hasSame(endDate, 'day') || (0, _chartUtils.isNumeric)(productionValue) && productionValue > 0 && elementDateTime > endDate && elementDateTime.hasSame(endDate, 'day')) {
        endDate = elementDateTime;
      }
    });
  }

  if (hasBattery) {
    Object.keys(batteryDictionary).forEach(function (element) {
      var elementDateTime = _luxon.DateTime.fromISO(batteryDictionary[element].readingEndTimeLocal, {
        zone: zone
      });

      var batteryValue = batteryDictionary[element];
    });
  }

  return {
    startDate: startDate === originalStartDate ? _luxon.DateTime.fromISO(dayISO, {
      zone: zone
    }).startOf('day') : startDate,
    endDate: endDate === originalEndDate ? _luxon.DateTime.fromISO(dayISO, {
      zone: zone
    }).endOf('day') : endDate
  };
};

var CustomerHourlyChart = function CustomerHourlyChart(_ref) {
  var batteryHourly = _ref.batteryHourly,
      chartSeriesType = _ref.chartSeriesType,
      enabledDataTypes = _ref.enabledDataTypes,
      dateISO = _ref.dateISO,
      siteProductionHourlyReadings = _ref.siteProductionHourlyReadings,
      weather = _ref.weather,
      zone = _ref.zone,
      desktopWidth = _ref.desktopWidth,
      mobileWidth = _ref.mobileWidth,
      minuteInterval = _ref.minuteInterval,
      children = _ref.children;
  var isBattery = false;
  var hasConsumption = enabledDataTypes.indexOf(_chartDataTypes.CONSUMPTION) > -1;
  var hasBattery = enabledDataTypes.indexOf(_chartDataTypes.BATTERY) > -1;
  var hasProduction = enabledDataTypes.indexOf(_chartDataTypes.PRODUCTION) > -1;
  var readingDictionary = siteProductionHourlyReadings.reduce(function (dictionary, reading) {
    var id = createKey(_luxon.DateTime.fromISO(reading.readingEndTimeLocal, {
      zone: zone
    }), minuteInterval);
    dictionary[id] = reading;
    return dictionary;
  }, {});
  var batteryDictionary = !hasBattery ? {} : batteryHourly.reduce(function (dictionary, reading) {
    var id = createKey(_luxon.DateTime.fromISO(reading.timeStamp, {
      zone: zone
    }), minuteInterval);
    dictionary[id] = reading;
    return dictionary;
  }, {});
  var edgeDates = getEdgeDates(dateISO, zone, readingDictionary, batteryDictionary, enabledDataTypes);
  var datesBetween = (0, _helpers.getDatesBetween)(edgeDates, {
    minute: minuteInterval === 60 ? 0 : undefined,
    second: 0
  }, minuteInterval === 60 ? 'hour' : 'minute', minuteInterval === 60 ? 1 : minuteInterval);
  var weatherDictionary = weather.data.reduce(function (dictionary, d) {
    var id = createKey(_luxon.DateTime.fromISO(d.date, {
      zone: zone
    }), minuteInterval);
    dictionary[id] = d;
    return dictionary;
  }, {});
  var productionCoordinates = [];
  var consumptionCoordinates = [];
  var batteryCoordinates = [];
  var groupedCoordinates = [];
  datesBetween.forEach(function (dt) {
    var x = createKey(dt, minuteInterval);
    var productionCoordinate = {
      x: x,
      y: hasProduction && readingDictionary[x] && !isNaN(readingDictionary[x].deliveredKwh) ? Number(readingDictionary[x].deliveredKwh) : 0,
      y0: 0,
      color: _colors.START_GRADIENT,
      type: _chartDataTypes.PRODUCTION,
      name: 'Production'
    };
    var consumptionCoordinate = {
      x: x,
      y: hasConsumption ? extractConsumptionValue(readingDictionary[x]) : 0,
      y0: 0,
      color: _colors.CUSTOMER_CONSUMPTION,
      type: _chartDataTypes.CONSUMPTION,
      name: 'Consumption'
    };
    var batteryCoordinate = {
      x: x,
      y: hasBattery && batteryDictionary[x] && !isNaN(batteryDictionary[x].averageBatteryPercentageState) ? Number(batteryDictionary[x].averageBatteryPercentageState) : 0,
      y0: 0,
      color: _colors.BATTERY,
      type: _chartDataTypes.BATTERY,
      name: 'Battery'
    };
    var groupedCoordinate = {
      x: x,
      y: 0,
      y0: 0,
      coordinates: []
    };

    if (hasProduction) {
      groupedCoordinate.coordinates.push(productionCoordinate);
    }

    if (hasConsumption) {
      groupedCoordinate.coordinates.push(consumptionCoordinate);
    }

    if (hasBattery) {
      groupedCoordinate.coordinates.push(batteryCoordinate);
    }

    productionCoordinates.push(productionCoordinate);
    consumptionCoordinates.push(consumptionCoordinate);
    batteryCoordinates.push(batteryCoordinate);
    groupedCoordinates.push(groupedCoordinate);
  });
  var maxValue = isBattery ? 100 : (0, _max["default"])(productionCoordinates.concat(consumptionCoordinates).map(function (c) {
    return c.y;
  }));
  var roundedMaxValue = Math.max(Math.ceil(maxValue / 5) * 5, 5);
  var tickValues = (0, _helpers.getTickValuesFromMax)(roundedMaxValue);
  var hasNoData = Object.keys(readingDictionary).length === 0;
  var widths = {
    mobile: mobileWidth ? mobileWidth : '2000px',
    desktop: desktopWidth ? desktopWidth : '1600px'
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ScrollableXYPlot["default"], {
    isBattery: false,
    hasNoData: hasNoData,
    roundedMaxValue: roundedMaxValue,
    tickValues: tickValues,
    widths: widths
  }, /*#__PURE__*/_react["default"].createElement(_CustomerDisplay["default"], {
    roundedMaxValue: roundedMaxValue,
    tickValues: tickValues,
    productionCoordinates: productionCoordinates,
    consumptionCoordinates: consumptionCoordinates,
    batteryCoordinates: batteryCoordinates,
    chartType: chartSeriesType,
    enabledDataTypes: enabledDataTypes,
    hasNoData: hasNoData,
    zone: zone,
    widths: widths,
    renderXAxisTick: function renderXAxisTick(isoDate) {
      var dt = _luxon.DateTime.fromISO(isoDate, {
        zone: zone
      });

      if (dt.get('minute') !== 0) {
        return null;
      }

      var icon = weatherDictionary[isoDate] ? weatherDictionary[isoDate].icon : null;
      var displayedLabel = dt.toFormat('ha');
      return /*#__PURE__*/_react["default"].createElement(_ChartTick["default"], {
        fill: _colors.WEATHER_ICON_COLOR,
        label: displayedLabel,
        icon: icon
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_CustomerInteraction["default"], {
    chartType: chartSeriesType,
    timeZone: zone,
    widths: widths,
    groupedCoordinates: groupedCoordinates,
    roundedMaxValue: roundedMaxValue,
    renderHint: function renderHint(selectedCoordinate) {
      return /*#__PURE__*/_react["default"].createElement(_CustomerHint["default"], {
        selectedCoordinate: selectedCoordinate,
        zone: zone,
        dateFormat: "h:mm a"
      });
    }
  }), hasNoData && children && /*#__PURE__*/_react["default"].createElement(_Styles.FillAvailableSpace, null, children)), /*#__PURE__*/_react["default"].createElement(_CustomerLegend["default"], {
    enabledDataTypes: enabledDataTypes
  }));
};

CustomerHourlyChart.propTypes = _defineProperty({
  chartSeriesType: _propTypes["default"].oneOf(['Line', 'Bar']),
  children: _propTypes["default"].node,
  dateISO: _propTypes["default"].string.isRequired,
  siteProductionHourlyReadings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    deliveredKwh: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    readingEndTimeLocal: _propTypes["default"].string
  })),
  batteryHourly: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    batteryPercentAverage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    timeStamp: _propTypes["default"].string
  })),
  weather: _propTypes["default"].shape({
    data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      date: _propTypes["default"].string.isRequired,
      icon: _propTypes["default"].string.isRequired,
      temperature: _propTypes["default"].number.isRequired
    }))
  }),
  zone: _propTypes["default"].string,
  enabledDataTypes: _propTypes["default"].arrayOf(_propTypes["default"].string),
  desktopWidth: _propTypes["default"].string,
  mobileWidth: _propTypes["default"].string,
  minuteInterval: _propTypes["default"].oneOf([15, 30, 60])
}, "children", _propTypes["default"].node);
CustomerHourlyChart.defaultProps = _defineProperty({
  children: undefined,
  siteProductionHourlyReadings: [],
  batteryHourly: [],
  weather: {
    data: []
  },
  zone: 'local',
  chartSeriesType: _chartDisplayTypes.BAR,
  enabledDataTypes: [_chartDataTypes.PRODUCTION],
  minuteInterval: 60
}, "children", null);
var _default = CustomerHourlyChart;
exports["default"] = _default;